/**
 * Amorçage de l'application.
 *
 * L'API du moteur reste `window.facturelire.extract(...)` : c'est le point
 * d'entrée stable sur lequel l'interface est branchée et que les tests
 * d'intégration utilisent.
 */
import './ui/styles.css';
import { createApp } from './ui/app';
import { disposeExtractionWorker, extractInvoice } from './lib/pdf/client';
import type { ExtractionResult } from './lib/model';

export interface FactureLireApi {
  extract(input: Blob | ArrayBuffer | Uint8Array, filename?: string): Promise<ExtractionResult>;
  dispose(): void;
  version: string;
}

const api: FactureLireApi = {
  extract: extractInvoice,
  dispose: disposeExtractionWorker,
  version: '0.3.0',
};

declare global {
  interface Window {
    facturelire: FactureLireApi;
  }
}

window.facturelire = api;

const root = document.getElementById('app');
if (root) {
  createApp(root, { extract: extractInvoice });
} else {
  console.error('[FactureLire] conteneur #app introuvable');
}

// Le Worker est libéré quand la page disparaît.
window.addEventListener('pagehide', () => disposeExtractionWorker());
